export default {
  text: {
    marginTop: 0,
    marginBottom: 0,
    height: 'auto',
    transformOrigin: '0 60%',
    transform: 'scale(1, 0.60)',
    borderRadius: 'sm',
    '&:empty:before': {
      content: '"\\00a0"'
    }
  },
  textFullHeight: {
    marginTop: 0,
    marginBottom: 0,
    height: 'auto',
    borderRadius: 'sm',
    '&:empty:before': {
      content: '"\\00a0"'
    }
  },
  circle: {
    borderRadius: '50%'
  },
  rect: {}
}
